let collectionBlockSwiper = new Swiper(".collection-blocks", {
    pagination: {
      el: ".collection-blocks .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".collection-blocks .swiper-button-next",
      prevEl: ".collection-blocks .swiper-button-prev",
    },
    loop: false,
    centeredSlides: false,
    slidesPerView: 2,
    spaceBetween: 0,
    autoHeight: false,
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 0,
      }
      }
  });